import { useTranslation } from "react-i18next";
import logo_adn from '../../assets/images/logos/logo_adn.png';
import mailtoIcon from '../../assets/images/svg/mailto.svg';
import phoneIcon from '../../assets/images/svg/phone.svg';
import './Footer.css';
import { useLocation } from 'react-router-dom';

const version = "3.0.2";

export default function Footer() {
  const location = useLocation();
  const { t } = useTranslation();

  if (location.pathname.startsWith('/report')) {
    return;
  }

  return (
    <footer className="c-footer">
      <div className="footer-content">
        <h2>{t('footer.title')}</h2>
        <p>{t('footer.partnership')}</p>
        <img src={logo_adn} alt="AdN logo" />
        <p>{t('footer.address')}</p>
        <div className="contact-info">
          <div className='contact-info-item'>
            <img src={phoneIcon} alt="Phone" />
            <a href={t('footer.phoneHref')}>{t('footer.phoneNumber')}</a>
          </div>
          <div className='contact-info-item'>
            <img src={mailtoIcon} alt="Mail" />
            <a href={t('footer.contactHref')}>{t('footer.contactByMail')}</a>
          </div>
        </div>
        <p>© { new Date().getFullYear() } - { t('footer.byDW') } - <a href='/legalinformation'>{ t('footer.privacyPolicy') }</a>
          <br />
          Version : {version}
        </p>
      </div>
    </footer>
  );
}